@use "../../../styles/variables.scss" as *;
@use "../../../styles/typography.scss" as *;

.pageContentHeaderOuter {
  @apply fixed top-0 left-0 right-0;
  margin-left: auto;
  margin-right: auto;
  background-color: $white;
  z-index: 10;

  .progressBar {
    background-color: rgba(37, 36, 35, 0.2);
    padding-top: 0;
    padding-bottom: 0;
  }

  .pageContentHeaderInner {
    .logoBar {
      @apply h-14;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-top: $spacing-sm;
      padding-bottom: $spacing-sm;
      padding-left: $spacing-sm;
      padding-right: $spacing-lg;
      border-bottom: 1px solid $light-beige;

      .backButtonFiller,
      .menuButtonFiller {
        width: 42px;
      }

      .backButtonContainerOuter {
        .backButtonContainerInner {
          button {
            border: 1px solid $beige;
            border-radius: 9999px;
            width: 40px;
            height: 40px;
            padding: 0;
            background-color: transparent;

            &:hover {
              border: 1px solid $almost-black;
            }

            svg {
              color: $almost-black;
            }
          }
        }
      }
      .logoContainer {
        display: flex;
        flex-direction: row;
        align-items: center;
        padding-left: $spacing-md;
        padding-right: $spacing-md;
        margin: $spacing-sm;
        a {
          display: flex;

          .logo {
            width: 8.1rem;
          }
        }
      }

      .rightButtons {
        @apply gap-4;
        display: flex;
        flex-direction: row;
        align-items: center;
        flex-shrink: 0;
      }

      .menuContainer {
        @apply w-10 h-10;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        border: 1px solid $beige;
        border-radius: 9999px;
        background-color: transparent;
        color: $almost-black;

        &:hover {
          border: 1px solid $almost-black;
        }
        img {
          max-width: 1rem;
        }
      }
    }
  }
  .trackerExteriorContainer {
    @apply w-full;
    border-color: $beige;
    .trackerOuterContainer {
      .progressTrackerContainerInner {
        @apply gap-2 w-full;
        display: flex;
        justify-content: space-between;
        padding-left: $spacing-lg;
        padding-right: $spacing-lg;
        .progressStep {
          @apply w-full h-3;
          background-color: $neutral-grey-200;
          border-radius: 9999px;
          &.completed {
            background-color: $almost-black;
          }
        }
      }
    }
  }
}
.mainMenu {
  @apply absolute w-48;
  right: $spacing-lg;
  top: 56px;
  background-color: $white;
  border-radius: 16px;
  box-shadow:
    0px 8.471px 29.647px -2.824px rgba(24, 39, 75, 0.12),
    0px 5.647px 12.706px -4.235px rgba(24, 39, 75, 0.12);
  .mainMenuItems {
    padding-top: $spacing-md;
    padding-bottom: $spacing-md;
  }
  .secondary_menu_items {
    border-top: 1px solid $beige;
    padding-top: $spacing-md;
    padding-bottom: $spacing-md;
  }
  .item {
    p {
      padding-top: $spacing-md;
      padding-bottom: $spacing-md;
      padding-left: $spacing-lg;
      padding-right: $spacing-lg;
      margin: 0;
      @include text-style("text-md");
    }
    &:hover {
      cursor: pointer;
      background-color: $solids-cream;
    }
  }

  button.item {
    background-color: transparent;
    color: $almost-black;
    border: none;
    width: 100%;
    text-align: left;
    padding: 12px 16px;
    border-radius: 0;
    font-weight: 500;
  }
}
